import type { DeserializeName } from '../use-name-serialization';

export const deserializeName: DeserializeName = (fieldName) => {
  const [section, name, index, subIndex] = fieldName.split('_');
  return {
    section,
    name,
    index: parseInt(index),
    subIndex: parseInt(subIndex),
  };
};
